import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@robocorp/theme';
import { Menu } from '@robocorp/components';
import { IconDashboard, IconSettingsSliders, IconCreditCard } from '@robocorp/icons/iconic';
import { CurrentUserRestriction, NavigationLink, OrganizationRestriction } from '~/components';
import { useCurrentOrFirstOrganization } from '~/queries';

const StyledMenuLink = styled(NavigationLink)`
  padding-left: ${({ theme }) => theme.space.$32};
`;

export const CurrentOrganizationNavigation: FC = () => {
  const { t } = useTranslation();
  const { data: currentOrganization } = useCurrentOrFirstOrganization<'safeToParse'>();

  return (
    <>
      <OrganizationRestriction organization={currentOrganization} permission="view_exec_dashboards">
        <StyledMenuLink
          data-testid="organization__menu-dashboard"
          component={Menu.Link}
          to={`/${currentOrganization.short_name}/dashboard`}
          icon={<IconDashboard />}
          end
        >
          {t('dashboard')}
        </StyledMenuLink>
      </OrganizationRestriction>
      <CurrentUserRestriction permission="canManageBilling">
        <OrganizationRestriction organization={currentOrganization} permission="manage_billing">
          <StyledMenuLink
            data-testid="organization__menu-billing"
            component={Menu.Link}
            to={`/${currentOrganization.short_name}/settings/billing`}
            icon={<IconCreditCard />}
            end
          >
            {t('planAndBilling')}
          </StyledMenuLink>
        </OrganizationRestriction>
      </CurrentUserRestriction>
      <StyledMenuLink
        data-testid="organization__menu-settings"
        component={Menu.Link}
        to={`/${currentOrganization.short_name}/settings`}
        icon={<IconSettingsSliders />}
        end
      >
        {t('settingsAndMembers')}
      </StyledMenuLink>
    </>
  );
};
